import { FC } from 'react';
import { cn } from '../../utility/cn';

// --- Components ---

/** * Wraps the entire Row (Label + Input). 
 * This abstracts the "row mb-6" boilerplate.
 */
export const FormRow: FC<{ children: React.ReactNode; className?: string }> = ({ children, className }) => (
    <div className={cn('row mb-6', className)}>{children}</div>
);

/**
 * Standardized Label
 */
export const FormLabel: FC<{ children: React.ReactNode; required?: boolean; width?: string }> = ({
    children,
    required,
    width = 'col-lg-4'
}) => (
    <label className={cn(width, 'col-form-label fw-bold fs-6', required && 'required')}>
        {children}
    </label>
);

/**
 * The Error Message (Red text)
 */
export const FormError: FC<{ error?: string }> = ({ error }) => {
    if (!error) return null;
    return (
        <div className="fv-plugins-message-container invalid-feedback">
            <div className="fv-help-block">{error}</div>
        </div>
    );
};

/**
 * Helper Text (Gray text)
 */
export const FormHelp: FC<{ children: React.ReactNode }> = ({ children }) => (
    <div className="form-text text-muted mt-2">{children}</div>
);



